
function Grant() {
  return (
    <div>GRANT</div>
  );
}

export default Grant;
